import React from "react";
import "./Location2.css";

import VenueImage from "../../image/TARUMT.png";
import TicketQR from "../../image/TEDxSetapak2026_Ticket_QR.png";

export default function Location2() {
  const registerUrl = "https://tinyurl.com/TedxSetapak2026V2";

  return (
    <section
      id="location2"
      className="bg-black text-white py-5"
    >
      <div
        className="container"
        style={{ maxWidth: "1000px" }}
      >

        {/* ================= HEADER ================= */}
        <div className="text-center mb-5">

          <h2 className="fw-semibold mb-3">
            Discover inspiring talks. Get your{" "}
            <span className="tedx-highlight">
              TEDxSetapak
            </span>{" "}
            2026 tickets now.
          </h2>

          <p
            className="mb-4"
            style={{
              color: "#9ACD32",
              fontSize: "1.1rem"
            }}
          >
            T.U.M.B.U.H – Change Worth Growing
          </p>

          <a
            href={registerUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-danger btn-lg"
            style={{
              width: "100%",
              maxWidth: "320px"
            }}
          >
            Register Now
          </a>

        </div>

        {/* ================= VENUE + TICKETS ================= */}
        <div className="row g-4">

          {/* ================= VENUE CARD ================= */}
          <div className="col-12 col-lg-6">

            <div className="card bg-dark border-0 shadow-lg rounded-4 overflow-hidden text-white h-100 p-4">

              <h4 className="fw-bold mb-3">
                Event Location
              </h4>

              {/* Event Information */}
              <div className="d-flex flex-wrap gap-2 mb-3">

                <span className="badge rounded-pill text-bg-secondary px-3 py-2">
                  31 Oct 2026
                </span>

                <span className="badge rounded-pill text-bg-secondary px-3 py-2">
                  9:00 AM – 5:00 PM
                </span>

                <span className="badge rounded-pill text-bg-secondary px-3 py-2">
                  Auditorium Hall
                </span>

              </div>

              {/* Venue Address */}
              <div className="venue-address mb-3">

                <p>
                  <strong>
                    Tunku Abdul Rahman University of
                    Management and Technology
                  </strong>
                </p>

                <p>
                  Auditorium Hall, Bangunan Tun Tan Siew Sin
                </p>

                <p>
                  Jalan Genting Kelang, Setapak,
                  53300 Kuala Lumpur
                </p>

                <p>
                  Federal Territory of Kuala Lumpur
                </p>

              </div>

              {/* Venue Image */}
              <div className="text-center mb-3">

                <img
                  src={VenueImage}
                  alt="TAR UMT Kuala Lumpur"
                  className="rounded-3 shadow venue-img"
                />

              </div>

              {/* Navigation Links */}
{/* Navigation Links */}
<div className="location2-navigation">

  <a
    href="https://g.co/kgs/65427EM"
    target="_blank"
    rel="noopener noreferrer"
    className="location2-map-btn"
  >
    <i className="fas fa-map-marked-alt" aria-hidden="true"></i>
    <span>Google Maps</span>
    <i className="fas fa-external-link-alt" aria-hidden="true"></i>
  </a>

  <a
    href="https://waze.com/ul/hw2866ck35"
    target="_blank"
    rel="noopener noreferrer"
    className="location2-map-btn"
  >
    <i className="fas fa-car" aria-hidden="true"></i>
    <span>Waze</span>
    <i className="fas fa-external-link-alt" aria-hidden="true"></i>
  </a>

</div>

            </div>

          </div>

          {/* ================= TICKET CARD ================= */}
          <div className="col-12 col-lg-6">

            <div className="card bg-dark border-0 shadow-lg rounded-4 overflow-hidden text-white h-100 p-4">

              <h4 className="fw-bold mb-4">
                Ticket Price
              </h4>

              {/* ================= TICKET PRICES ================= */}
              <div className="row g-3 mb-4">

                {/* Normal Ticket */}
                <div className="col-6">
                  <div
                    className="rounded-3 p-3 h-100"
                    style={{
                      backgroundColor: "#2C3034",
                      border: "1px solid #495057"
                    }}
                  >
                    <p className="fw-semibold mb-2">
                      Normal Ticket
                    </p>

                    <h2 className="fw-bold text-white mb-1">
                      RM118
                    </h2>

                    <p className="text-white-50 small mb-0">
                      Per person
                    </p>
                  </div>
                </div>

                {/* Group Ticket */}
                <div className="col-6">
                  <div
                    className="rounded-3 p-3 h-100"
                    style={{
                      backgroundColor: "#2C3034",
                      border: "1px solid #9ACD32"
                    }}
                  >
                    <p
                      className="fw-semibold mb-2"
                      style={{ color: "#9ACD32" }}
                    >
                      Buy 2 or More
                    </p>

                    <h2
                      className="fw-bold mb-1"
                      style={{ color: "#9ACD32" }}
                    >
                      RM99
                    </h2>

                    <p className="text-white-50 small mb-0">
                      Per person
                    </p>
                  </div>
                </div>

              </div>

              <hr className="border-secondary mb-4" />

              {/* ================= QR CODE ================= */}
              <div className="text-center mt-3">

                <h5
                  className="fw-bold mb-3"
                  style={{ color: "#9ACD32" }}
                >
                  Get Your Tickets Now!
                </h5>

                <p className="text-white-50 mb-3">
                  Scan the QR code or visit the registration link.
                </p>

                {/* Existing QR Code PNG */}
                <div
                  className="bg-white rounded-3 p-3 mx-auto"
                  style={{
                    width: "fit-content"
                  }}
                >
                  <img
                    src={TicketQR}
                    alt="TEDxSetapak 2026 Ticket Registration QR Code"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "contain",
                      display: "block"
                    }}
                  />
                </div>

                {/* Registration URL */}
                <div className="mt-3">

                  <a
                    href={registerUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-info text-decoration-underline"
                    style={{
                      fontSize: "0.9rem",
                      overflowWrap: "anywhere"
                    }}
                  >
                    {registerUrl}
                  </a>

                </div>

                {/* Register Button */}
                <a
                  href={registerUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-danger btn-lg mt-4"
                  style={{
                    width: "100%",
                    maxWidth: "320px"
                  }}
                >
                  Register Now
                </a>

              </div>

            </div>

          </div>

        </div>


      </div>
    </section>
  );
}